/**
 * Agent Test Modal Component
 * 
 * Modal dialog for testing an agent with an embedded chat interface.
 */

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { AgentTestChat } from './AgentTestChat';

interface AgentTestModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  agent: {
    id: string;
    name: string;
  } | null;
}

export function AgentTestModal({
  open,
  onOpenChange,
  agent,
}: AgentTestModalProps) {
  if (!agent) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Test Agent</DialogTitle>
        </DialogHeader>
        <AgentTestChat agentId={agent.id} agentName={agent.name} />
      </DialogContent>
    </Dialog>
  );
}
